import * as THREE from 'three'
import { useActsStore } from '../store/useActsStore'

const FPS_REF = 60 // mets 240 si ton feeling "avant" était calibré sur ton écran 240Hz

function frameLerpAlpha(speed, delta) {
  // speed = facteur lerp "par frame" (ex: 0.05)
  // delta = secondes écoulées
  // alpha = facteur équivalent indépendant du FPS
  speed = THREE.MathUtils.clamp(speed, 0, 1)
  return 1 - Math.pow(1 - speed, delta * FPS_REF)
}

export function moveAxis(
  ref,
  axis,
  value,
  speed = 0.05,
  easing = "linear",
  easeMul = 1,
  delta
) {
  const current = ref.current.position[axis]
  const target = value

  let t = speed

  switch (easing) {
    case "easeIn":
      t = Math.pow(speed, 2) * easeMul
      break

    case "easeOut":
      t = (1 - Math.pow(1 - speed, 2)) * easeMul
      break

    case "easeInOut":
      t = speed < 0.5
        ? (2 * Math.pow(speed, 2)) * (easeMul / 2)
        : (1 - Math.pow(-2 * speed + 2, 2) / 2) * (easeMul / 2)
      break

    default:
      t = speed
  }

  t = THREE.MathUtils.clamp(t, 0, 1)

  ref.current.position[axis] = THREE.MathUtils.lerp(
    current,
    target,
    frameLerpAlpha(t, delta)
  )
}

export function moveAxisRange(
  ref,
  axis,
  base,
  value,
  progress,
  start,
  end,
  speed = 0.05,
  delta,
  holdBeforeStart = true
) {
  if (!ref?.current) return

  if (!holdBeforeStart && progress < start) return

  const t = THREE.MathUtils.clamp((progress - start) / (end - start), 0, 1)
  const current = ref.current.position[axis]
  const target = base + t * value

  ref.current.position[axis] = THREE.MathUtils.lerp(
    current,
    target,
    frameLerpAlpha(speed, delta)
  )
}

export function rotateAxisRange(
  ref,
  axis,
  base,
  value,
  progress,
  start,
  end,
  speed = 0.05,
  delta
) {
  const t = THREE.MathUtils.clamp((progress - start) / (end - start), 0, 1)
  const current = ref.current.rotation[axis]
  const target = base + t * value

  ref.current.rotation[axis] = THREE.MathUtils.lerp(
    current,
    target,
    frameLerpAlpha(speed, delta)
  )
}

export function scaleRange(
  ref,
  base,
  value,
  progress,
  start,
  end,
  speed,
  delta,
  activeOnly = true
) {
  if (!ref?.current) return

  if (activeOnly && (progress < start || progress > end)) return

  const t = THREE.MathUtils.clamp((progress - start) / (end - start), 0, 1)
  const target = base + value * t

  const current = ref.current.scale.x
  const alpha = frameLerpAlpha(speed, delta)
  const next = THREE.MathUtils.lerp(current, target, alpha)

  ref.current.scale.set(next, next, next)
}

export function moveProperties(
  ref,
  property,
  target,
  speed,
  delta
) {
  if (!ref.current) return

  ref.current[property] = THREE.MathUtils.lerp(
    ref.current[property],
    target,
    frameLerpAlpha(speed, delta)
  )
}


export function movePropertiesRange(
  id,
  ref,
  property,
  base,
  value,
  progress,
  start,
  end,
  resetOutside = true
) {
  if (!ref.current) return

  const stateActe = useActsStore.getState()
  const phase = stateActe.actsProgress[id]?.phase

  if (phase !== 'hold') return

  if (progress <= start) {
    if (resetOutside) ref.current[property] = base
    return
  }

  if (progress >= end) {
    if (resetOutside) ref.current[property] = base + value
    return
  }

  const t = (progress - start) / (end - start)
  ref.current[property] = base + t * value
}
